import { createListenerMiddleware } from '@reduxjs/toolkit';
import { Filters, sortingHelper } from '@ui/src';
import { CustomersRootState } from '../../../../store/state';
import { cardsTransactionFiltersHelper } from './fitlers-helper';
import {
  getCardsTransactions as getCardsPageTransactions,
  getCardsTransactionsSuccess as getCardsPageTransactionsSuccess,
  onFilterCardsTransactionsList as onFilterCardsPageTransactionsList,
  onFilterListCardsTransactionsSuccess as onFilterCardsPageTransactionsListSuccess,
  onSortCardsTransactionsList as onSortCardsPageTransactionsList,
  onSortCardsTransactionsListSuccess as onSortCardsPageTransactionsListSuccess,
  getCards,
  getCardsSuccess,
  onCardStatusChange,
  onCardStatusChangeSuccess,
  onSubmitCard,
  onSubmitCardSuccess,
  getCardInfo,
  getCardInfoSuccess,
} from '../../../common/store/slices/cards';
import {
  getCardsTransactions as getCardsStatementsTransactions,
  getCardsTransactionsSuccess as getCardsStatementsTransactionsSuccess,
  onFilterCardsTransactionsList as onFilterCardsStatementsTransactionsList,
  onFilterListCardsTransactionsSuccess as onFilterCardsStatementsTransactionsListSuccess,
  onSortCardsTransactionsList as onSortCardsStatementsTransactionsList,
  onSortCardsTransactionsListSuccess as onSortCardsStatementsTransactionsListSuccess,
} from '../../../common/store/slices/statements';
import getCardAvailableStatuses from '../../../../helpers/get-card-available-statuses';
import {
  CardPaymentSystem,
  CardStatus,
  CustomerCard,
} from '../../../common/cards/types';
import { CardsTransactions } from '../../../common/types';

const customerCardsTransactionsMock: CardsTransactions[] = [
  {
    id: 'uuid-1',
    date: new Date().toISOString(),
    description: 'Chargeback',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-2',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '38.00',
    merchantName: 'Five guys',
    orderDetails: '448-89808',
  },
  {
    id: 'uuid-3',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '117.50',
    merchantName: 'Five guys',
    orderDetails: '55874108/898',
  },
  {
    id: 'uuid-4',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'canceled',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Order 78881-1',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-5',
    date: new Date().toISOString(),
    description: 'Debit',
    currency: 'EUR',
    amount: '-48.00',
    merchantName: 'Five guys',
    orderDetails: 'Order35532',
  },
  {
    id: 'uuid-6',
    date: new Date().toISOString(),
    description: 'Debit',
    transaction: 'warning',
    currency: 'EUR',
    amount: '-345.00',
    merchantName: 'Five guys',
    orderDetails: '16778900-34',
  },
  {
    id: 'uuid-7',
    date: new Date().toISOString(),
    description: 'Refund',
    currency: 'EUR',
    amount: '-38.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-8',
    date: new Date().toISOString(),
    description: 'Credit',
    transaction: 'good',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-9',
    date: new Date().toISOString(),
    description: 'Chargeback',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
  {
    id: 'uuid-10',
    date: new Date().toISOString(),
    description: 'Chargeback',
    currency: 'EUR',
    amount: '345.00',
    merchantName: 'Five guys',
    orderDetails: 'XID0900123',
  },
];

const customerCardsMock: CustomerCard[] = [
  {
    id: 'uuid-1',
    paymentSystem: CardPaymentSystem.VISA,
    number: '**57 8478',
    expiredDate: new Date('2028-01-04').toISOString(),
    balance: '587.54',
    balanceCurrency: 'eur',
    status: CardStatus.NEW,
    customerAccountId: '3.0.00.000001',
    address: 'United Kingdom, London, Apt. 203, 23, Baker street, W1 5DE',
    customerFirstName: 'James',
    customerLastName: 'Bond',
    virtual: false,
  },
  {
    id: 'uuid-2',
    paymentSystem: CardPaymentSystem.MASTER_CARD,
    number: '**57 8478',
    expiredDate: new Date('2028-01-04').toISOString(),
    balance: undefined,
    balanceCurrency: 'eur',
    status: CardStatus.ORDERED,
    customerAccountId: '3.0.00.000001',
    address: 'United Kingdom, London, Apt. 203, 23, Baker street, W1 5DE',
    customerFirstName: 'James',
    customerLastName: 'Bond',
    virtual: true,
  },
  {
    id: 'uuid-3',
    paymentSystem: CardPaymentSystem.MASTER_CARD,
    number: '**57 8478',
    expiredDate: new Date('2028-01-04').toISOString(),
    balance: '587.54',
    balanceCurrency: 'eur',
    status: CardStatus.ACTIVE,
    customerAccountId: '3.0.00.000001',
    address: 'United Kingdom, London, Apt. 203, 23, Baker street, W1 5DE',
    customerFirstName: 'James',
    customerLastName: 'Bond',
    virtual: false,
  },
  {
    id: 'uuid-4',
    paymentSystem: CardPaymentSystem.VISA,
    number: '**57 8478',
    expiredDate: new Date('2028-01-04').toISOString(),
    balance: '587.54',
    balanceCurrency: 'eur',
    status: CardStatus.FROZEN,
    customerAccountId: '3.0.00.000001',
    address: 'United Kingdom, London, Apt. 203, 23, Baker street, W1 5DE',
    customerFirstName: 'James',
    customerLastName: 'Bond',
    virtual: false,
  },
  {
    id: 'uuid-5',
    paymentSystem: CardPaymentSystem.VISA,
    number: '**57 8478',
    expiredDate: new Date('2028-01-04').toISOString(),
    balance: '587.54',
    balanceCurrency: 'eur',
    status: CardStatus.CANCELED,
    customerAccountId: '3.0.00.000001',
    address: 'United Kingdom, London, Apt. 203, 23, Baker street, W1 5DE',
    customerFirstName: 'James',
    customerLastName: 'Bond',
    virtual: false,
  },
  {
    id: 'uuid-6',
    paymentSystem: CardPaymentSystem.VISA,
    number: '**57 8478',
    expiredDate: new Date('2028-01-04').toISOString(),
    balance: '587.54',
    balanceCurrency: 'eur',
    status: CardStatus.VOID,
    customerAccountId: '3.0.00.000001',
    address: 'United Kingdom, London, Apt. 203, 23, Baker street, W1 5DE',
    customerFirstName: 'James',
    customerLastName: 'Bond',
    virtual: true,
  },
];

const customerMiddleware = createListenerMiddleware();

customerMiddleware.startListening({
  actionCreator: getCardsPageTransactions,
  effect: async (action, listenerApi) => {
    let nextList: CardsTransactions[] = customerCardsTransactionsMock;

    if (action.payload) {
      if (
        action.payload.name &&
        action.payload.direction &&
        !action.payload.filters
      ) {
        nextList = sortingHelper<CardsTransactions>(
          customerCardsTransactionsMock,
          action.payload.name,
          action.payload.direction,
        );
      }

      if (action.payload.filters) {
        const nextFilters: Filters = {};

        Object.keys(action.payload.filters).forEach((key) => {
          if (
            (action?.payload?.filters as Filters)[key] &&
            (action.payload.filters as Filters)[key].value.length < 2
          ) {
            nextFilters[key] = {
              ...nextFilters[key],
              value: [(action.payload.filters as Filters)[key].value.join()],
            };
          } else {
            nextFilters[key] = (action?.payload?.filters as Filters)[key];
          }
        });

        nextList = cardsTransactionFiltersHelper(
          customerCardsTransactionsMock,
          action.payload?.name as string,
          action.payload?.direction as 'asc' | 'desc',
          nextFilters,
        );
      }
    }

    setTimeout(() => {
      listenerApi.dispatch(getCardsPageTransactionsSuccess(nextList));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: onSortCardsPageTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerCards: { values },
    } = listenerApi.getState() as CustomersRootState;

    if (values) {
      const nextTransactions = sortingHelper<CardsTransactions>(
        [...values],
        action.payload.name,
        action.payload.direction,
      );

      setTimeout(() => {
        listenerApi.dispatch(
          onSortCardsPageTransactionsListSuccess(nextTransactions),
        );
        listenerApi.cancelActiveListeners();
      }, 1000);
    }
  },
});

customerMiddleware.startListening({
  actionCreator: onFilterCardsPageTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerCards: { sort },
    } = listenerApi.getState() as CustomersRootState;

    const nextFilters: Filters = {};

    Object.keys(action.payload).forEach((key) => {
      if (action.payload[key] && action.payload[key].value.length < 2) {
        nextFilters[key] = {
          ...nextFilters[key],
          value: [action.payload[key].value.join()],
        };
      } else {
        nextFilters[key] = action.payload[key];
      }
    });

    const nextTrancastions = cardsTransactionFiltersHelper(
      customerCardsTransactionsMock,
      sort?.sortProp as string,
      sort?.sortDir as 'asc' | 'desc',
      nextFilters,
    );

    setTimeout(() => {
      listenerApi.dispatch(
        onFilterCardsPageTransactionsListSuccess(nextTrancastions),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: getCardsStatementsTransactions,
  effect: async (action, listenerApi) => {
    let nextList: CardsTransactions[] = customerCardsTransactionsMock;

    if (action.payload) {
      if (
        action.payload.name &&
        action.payload.direction &&
        !action.payload.filters
      ) {
        nextList = sortingHelper<CardsTransactions>(
          customerCardsTransactionsMock,
          action.payload.name,
          action.payload.direction,
        );
      }

      if (action.payload.filters) {
        const nextFilters: Filters = {};

        Object.keys(action.payload.filters).forEach((key) => {
          if (
            (action?.payload?.filters as Filters)[key] &&
            (action.payload.filters as Filters)[key].value.length < 2
          ) {
            nextFilters[key] = {
              ...nextFilters[key],
              value: [(action.payload.filters as Filters)[key].value.join()],
            };
          } else {
            nextFilters[key] = (action?.payload?.filters as Filters)[key];
          }
        });

        nextList = cardsTransactionFiltersHelper(
          customerCardsTransactionsMock,
          action.payload?.name as string,
          action.payload?.direction as 'asc' | 'desc',
          nextFilters,
        );
      }
    }

    setTimeout(() => {
      listenerApi.dispatch(getCardsStatementsTransactionsSuccess(nextList));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: onSortCardsStatementsTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerStatements: {
        cardsTransactions: { values },
      },
    } = listenerApi.getState() as CustomersRootState;

    if (values) {
      const nextTransactions = sortingHelper<CardsTransactions>(
        [...values],
        action.payload.name,
        action.payload.direction,
      );

      setTimeout(() => {
        listenerApi.dispatch(
          onSortCardsStatementsTransactionsListSuccess(nextTransactions),
        );
        listenerApi.cancelActiveListeners();
      }, 1000);
    }
  },
});

customerMiddleware.startListening({
  actionCreator: onFilterCardsStatementsTransactionsList,
  effect: async (action, listenerApi) => {
    const {
      customerStatements: {
        cardsTransactions: { sort },
      },
    } = listenerApi.getState() as CustomersRootState;

    const nextFilters: Filters = {};

    Object.keys(action.payload).forEach((key) => {
      if (action.payload[key] && action.payload[key].value.length < 2) {
        nextFilters[key] = {
          ...nextFilters[key],
          value: [action.payload[key].value.join()],
        };
      } else {
        nextFilters[key] = action.payload[key];
      }
    });

    const nextTrancastions = cardsTransactionFiltersHelper(
      customerCardsTransactionsMock,
      sort?.sortProp as string,
      sort?.sortDir as 'asc' | 'desc',
      nextFilters,
    );

    setTimeout(() => {
      listenerApi.dispatch(
        onFilterCardsStatementsTransactionsListSuccess(nextTrancastions),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: getCards,
  effect: async (action, listenerApi) => {
    const nextCards = customerCardsMock.map((item) => {
      const result = { ...item };

      result.availableStatuses = getCardAvailableStatuses(item.status);

      return result;
    });

    setTimeout(() => {
      listenerApi.dispatch(getCardsSuccess(nextCards));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: onSubmitCard,
  effect: async (action, listenerApi) => {
    const {
      customerCards: { cards, orderCardFormValues },
    } = listenerApi.getState() as CustomersRootState;

    const nextCards = ([] as CustomerCard[]).concat(cards as CustomerCard[]);

    let card: CustomerCard = {
      id: `uuid-${nextCards.length + 1}`,
      paymentSystem: orderCardFormValues?.paymentSystem as CardPaymentSystem,
      number: '**57 8478',
      expiredDate: new Date('2028-01-04').toISOString(),
      balanceCurrency: 'eur',
      status: CardStatus.ORDERED,
      customerAccountId: '3.0.00.000001',
      address: '',
      customerFirstName: 'James',
      customerLastName: 'Bond',
      availableStatuses: getCardAvailableStatuses(CardStatus.ORDERED),
      virtual: !orderCardFormValues?.physical,
    };

    if (orderCardFormValues?.physical) {
      card = {
        ...card,
        address: `${orderCardFormValues.countryName}, ${orderCardFormValues.city}, ${orderCardFormValues.apartment}, ${orderCardFormValues.street}, ${orderCardFormValues.postCode}`,
        countryId: orderCardFormValues?.countryId,
        city: orderCardFormValues?.city,
        postCode: orderCardFormValues?.postCode,
        street: orderCardFormValues?.street,
        apartment: orderCardFormValues?.apartment,
      };
    }

    nextCards.push(card);

    setTimeout(() => {
      listenerApi.dispatch(onSubmitCardSuccess(nextCards));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: getCardInfo,
  effect: async (action, listenerApi) => {
    const {
      customerCards: { cards, cardId },
    } = listenerApi.getState() as CustomersRootState;

    const currentCard = cards?.find((item) => item.id === cardId);

    setTimeout(() => {
      listenerApi.dispatch(getCardInfoSuccess(currentCard as CustomerCard));
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

customerMiddleware.startListening({
  actionCreator: onCardStatusChange,
  effect: async (action, listenerApi) => {
    const {
      customerCards: { cards },
    } = listenerApi.getState() as CustomersRootState;

    const nextCards = cards?.map((item) => {
      const result = { ...item };

      if (result.id === action.payload.id) {
        result.status = action.payload.status;
        result.availableStatuses = getCardAvailableStatuses(
          action.payload.status,
        );
      }

      return result;
    });

    setTimeout(() => {
      listenerApi.dispatch(
        onCardStatusChangeSuccess(nextCards as CustomerCard[]),
      );
      listenerApi.cancelActiveListeners();
    }, 1000);
  },
});

export default customerMiddleware;
